import { WidgetsNotificationsMain } from '@/widgets/notifications';

export const PagesNotificationsMain = () => <WidgetsNotificationsMain />;
